import { gql, useApolloClient } from '@apollo/client';

import getZipcode from 'commons/getZipcode';
import { GET_CART } from 'mocks/queries';

const useEmptyCart = () => {
  const client = useApolloClient();

  const emptyCart = async () => {
    await client.mutate({
      mutation: gql`
        mutation emptyCart {
          emptyTheCart
        }
      `,
      refetchQueries: [
        { query: GET_CART, variables: { zipCode: getZipcode() } },
      ],
    });
  };

  return emptyCart;
};

export default useEmptyCart;
